import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import DashboardService from "src/apis/DashboardService";
import { toast } from "react-toastify";
import { withNamespaces } from "react-i18next";
import BarChart from "../../../Charts/BarChart";

const DashboardInvestigationTime = ({ t, filters, modules }) => {
  const { data: dashboardData, isFetching: summaryIsFetching } = useQuery({
    queryKey: ["wb-cm-fetch-admin-dashboard-summary-query", filters],
    queryFn: async () => {
      const service = DashboardService.getInstance();
      return await service.fetchSummary(
        {
          ...filters,
          excludeDeleted: (filters.exclude || []).includes("deleted_cases"),
          excludeTestCases: (filters.exclude || []).includes("test_cases"),
          exclude: undefined,
        },
        modules?.active
      );
    },
    cacheTime: 0,
    refetchOnWindowFocus: false,
    onError: (error) => {
      if (process.env.NODE_ENV === "development") console.error(error);

      toast(t("An error occurred while fetching dashboard data."), {
        type: "error",
      });
    },
  });

  return (
    <BarChart
      title="Processing time in days"
      data={dashboardData?.investigationTime || {}}
      isLoading={summaryIsFetching}
    />
  );
};

export default withNamespaces()(DashboardInvestigationTime);
